module.exports = __webpack_public_path__ + "static/media/Nikonorov.afc58abc.png";